import { useColorMode } from "@chakra-ui/color-mode";
import css from "@chakra-ui/css";
import { get, runIfFn } from "@chakra-ui/utils";
import { Global } from "@emotion/core";
import * as React from "react";
export function GlobalStyle() {
  var _useColorMode = useColorMode(),
      colorMode = _useColorMode.colorMode;

  return /*#__PURE__*/React.createElement(Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = get(theme, "styles.global");
      var styleObject = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!styleObject) return;
      var styles = css({
        body: styleObject
      })(theme);
      return styles;
    }
  });
}